import React from 'react'
import { screens } from './institutionalServiceHelper.js'
import { getRelativeBasePath } from '../../../../global/environments/path'
export default function InstitutionalCancelVerification({
  screenChangeHandler,
}) {
  const onContinueClicked = () => {
    screenChangeHandler(screens.FORGOT_PASSWORD_SCREEN)
  }

  const onCancleClick = () => {
    window.location.href = getRelativeBasePath() + '/login'
  }

  return (
    <div className="u-sizeConstrained">
      <div
        className="Content u-marginVert10gu u-bgColorLightest"
        data-analytics-login-step="User Id"
      >
        <div className="Grid">
          <div className="u-sizeFull u-lg-size12of12 u-lg-after1of12 Content">
            <h2 className="u-marginTop0 u-marginBottom4gu">
              Cancel Verification
            </h2>
            <p className="u-marginBottom8gu">
              We need to check your identity before you can login. Are you sure
              you want to leave this page?
            </p>
            <div className="Grid Grid--withGutter u-lg-size6of12 ">
              <div className="u-size6of12">
                <button
                  onClick={onContinueClicked}
                  className="Button Button--primary Button--block u-marginRight5gu u-marginBottom3gu u-paddingHoriz8gu u-textNoTransform"
                >
                  Continue Verification
                </button>
              </div>
              <div className="u-size6of12">
                <button
                  onClick={onCancleClick}
                  className="Button Button--tertiary Button--block u-paddingHoriz8gu"
                >
                  Leave
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
